import React, { Component } from 'react';
import {Select, Drawer, DatePicker, Table, Menu, Dropdown} from "antd";
import moment from 'moment-timezone';
import {orderBy} from 'lodash';

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import DataTable from "./DataTable";
import Loader from "../../../Common/Component/Loader";
import AddLead from './AddLead';
import {EllipsisOutlined} from "@ant-design/icons";
import {FilterOutlined} from '@ant-design/icons';
import {errorHandle} from "../../../Common/errorHandle";

const {Option} = Select;
const { RangePicker } = DatePicker;

const satisfaction_score = [{key: '>=90', value: '90% or Greater 90%'},
  {key: '>=75', value: '75% or Greater'},
  {key: '<75', value: '75% or Less'},
  {key: '<50', value: '50% or Less'},
]

let isLeadClicked = false;

class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myId: JSON.parse(localStorage.getItem('authUser'))?.user?.uuid,
      customerList: {},
      franchiseList: {},
      leadList: {},
      customerListPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activePagination: '15',
      leadListPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activeLeadPagination: '15',
      isCustomer: isLeadClicked ? false : true,
      filterData: {
        franchise: 'all',
        active: false,
        inactive: false,
        filterFranchise: '',
        joined: [],
        lastService: [],
        outstanding: 'all',
        satisfaction: ''
      },
      filterLeadData: {
        franchise: 'all',
        active: false,
        inactive: false,
        filterFranchise: '',
        lead_stage: 'all',
        outreach: 'all',
        first_contacted: [],
        last_contacted: []
      },
      openDrawer: false,
      openLeadDrawer: false,
      loader: false,
      search_value: '',
      lead_search_value: '',
      showAddLeadDrawer: false,
      errors: {},
      is_customer_filter:false,
      logged_in_user_role: [],
      current_tab: 1
    }
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.tab;
    if (id) {
      this.setState({
        current_tab:0
      })
    }
    this.setState({loader: true});
    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    this.setState({logged_in_user_role}, () => {
      this.callApi()
    })
    this.props.getFranchise(); // get franchise list
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {customerList, franchiseList, leadList} = this.state;
    this.setState({loader: false});
    ///////////////// errors ////////////////////////////////
    if (nextProps?.residentialError && Object.keys(nextProps?.residentialError).length > 0 && nextProps?.residentialError !== this.props?.residentialError) {
      this.setState({loader: false});
      errorHandle(nextProps?.residentialError)
    }

    if (nextProps?.settingError && Object.keys(nextProps?.settingError).length > 0 && nextProps?.settingError !== this.props?.settingError) {
      this.setState({loader: false});
      errorHandle(nextProps?.settingError)
    }

    ///////////////////////////////////////////////////////////////////////

    // get customer list
    if (Object.keys(nextProps?.customerList).length > 0 && JSON.stringify(nextProps?.customerList) !== JSON.stringify(customerList)) {
      this.setState({customerList: nextProps?.customerList});
    }

    // get franchise list
    if (Object.keys(nextProps?.franchiseData).length > 0 && JSON.stringify(nextProps?.franchiseData) !== JSON.stringify(franchiseList)) {
      this.setState({franchiseList: nextProps?.franchiseData});
    }

    // get lead list
    if (Object.keys(nextProps?.Lead?.leadList).length > 0 && JSON.stringify(nextProps?.Lead?.leadList) !== JSON.stringify(leadList)) {
      this.setState({leadList: nextProps?.Lead?.leadList});
    }    
  }

  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr')
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    return {is_franchise_owner, franchise_uuid: franchise_uuid?.[0], is_disable_franchise_dropdown: (is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)}
  }

  onSearchValue = (e) =>{
    this.setState({search_value: e.target.value})
  }

  // on search
  onSearch = (e) => {
    const {activePagination, activeLeadPagination, current_tab, customerListPagination, leadListPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({search_value: e.target.value}, () => {
      const {search_value} = this.state;
      if (current_tab === 1 && (search_value?.length >= 3 || search_value?.length === 0)) {
        setTimeout(() => {
          this.setState({
            customerList:[]
          })
          this.props.getCustomers({
            offset: 0,
            is_active: true,
            limit: activePagination,
            ordering: '-created_at',
            q: this.state.search_value,
            serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : ''
          });
          this.setState({customerListPagination: {...customerListPagination, current: 1},
            filterData: {
              franchise: 'all',
              active: false,
              inactive: false,
              filterFranchise: '',
              joined: [],
              lastService: [],
              outstanding: 'all',
              satisfaction: ''
            }
          })
        }, 2000)
      } else if (current_tab === 0 && (search_value?.length >= 3 || search_value?.length === 0)) {
        setTimeout(() => {
          this.props.getLeads({limit: activeLeadPagination, offset: 0, ordering: '', q: this.state.search_value, field_office__uuid : is_franchise_owner ? franchise_uuid : ''})
          this.setState({leadListPagination: {...leadListPagination, current: 1},
            filterLeadData: {
              franchise: 'all',
              active: false,
              inactive: false,
              filterFranchise: '',
              lead_stage: 'all',
              outreach: 'all',
              first_contacted: [],
              last_contacted: []
            }
          })
        },2000)
      } else if (current_tab === 2 && (search_value?.length >= 3 || search_value?.length === 0)) {
        setTimeout(() => {
          this.setState({
            customerList:[]
          })
          this.props.getCustomers({
            offset: 0,
            limit: activePagination,
            ordering: '-created_at',
            q: this.state.search_value,
            is_active: false,
            serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : ''
          });
          this.setState({customerListPagination: {...customerListPagination, current: 1},
            filterData: {
              active: false,
              inactive: false,
              franchise: 'all',
              joined: [],
              lastService: [],
              outstanding: [],
              satisfaction: ''
            }
          })
        }, 2000)
      }
    });
  };

  // on switch tab
  switchTab = (value) => {
    this.setState({current_tab: value}, () => {
      this.setCustomerPageLimit('15');
      this.setLeadPageLimit('15');
      this.callApi()
    })
  };

  callApi = () => {
    const {activePagination, activeLeadPagination, current_tab, search_value} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({loader: true});
    if (current_tab === 1) {
      // get list of customers
      this.setState({
        filterData: {
          active: false,
          inactive: false,
          franchise: 'all',
          joined: [],
          lastService: [],
          outstanding: [],
          satisfaction: ''
        }}, () => this.props.getCustomers({
          limit: activePagination,
          offset: 0,
          q: search_value,
          serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
          ordering: '-created_at',
          is_active: true 
        }) );
    } else if (current_tab === 0) {
      this.props.getLeads({
        limit: activeLeadPagination,
        offset: 0,
        q: search_value,
        field_office__uuid: is_franchise_owner ? franchise_uuid : '',
        is_active : true
      }); // get list of leads
    } else if (current_tab === 2) {
      this.setState({
        filterData: {
          active: false,
          inactive: false,
          franchise: 'all',
          joined: [],
          lastService: [],
          outstanding: [],
          satisfaction: ''
        }}, () => this.props.getCustomers({
          limit: activePagination,
          offset: 0,
          q: search_value,
          serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
          ordering: '-created_at',
          is_active: false
        }) )
    }
  }

  // toggle add leader drawer
  toggleAddLeadDrawer = (value) => {
    this.setState({showAddLeadDrawer: value})
  };

  // add zero before number
  leadingZeros = (value, size) => {
    let s = String(value);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  ////////////////////////////////////////// Customer /////////////////////////////
  // filter data change
  onFilterChange = (e, type, name) => {
    const {filterData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterData, {[e.target.name]: value});
    this.setState({filterData}, () => {
      if (name === 'franchise') {
        this.onFilterClick()
      }
    });
  };

  // on filter click
  onFilterClick = () => {
    const {filterData, activePagination, filters, current_tab} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({loader: true, search_value: ''});
    const obj = {
      offset: 0,
      limit: activePagination,
      ordering: '-created_at',
      serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
      is_active: current_tab === 1,
    };

    if (filters?.franchise || (filterData?.franchise && filterData?.franchise !== 'all')) {
      Object.assign(obj, {serviceorder__field_office__uuid: filters?.franchise?.toString() || filterData?.franchise});
    }
    if (filterData?.joined?.length > 0) {
      Object.assign(obj, {created_at__lte: new Date(filterData?.joined?.[1]), created_at__gte: new Date(filterData?.joined?.[0])});
    }
    if (filterData?.lastService?.length > 0) {
      Object.assign(obj, {last_serviced: `${moment(filterData?.lastService?.[0]).format('YYYY-MM-DD')},${moment(filterData?.lastService?.[1]).format('YYYY-MM-DD')}`});
    }

    if(filterData?.satisfaction) {
      if(filterData?.satisfaction === '>=90' || filterData?.satisfaction === '>=75' ) {
        Object.assign(obj, {customer_satisfaction_score__gte: filterData?.satisfaction ? filterData?.satisfaction === '>=90' ? '90' : '75' : ''})
      }
      else {
        Object.assign(obj, {customer_satisfaction_score__lte: filterData?.satisfaction ? filterData?.satisfaction === '<75' ? '75' : '50' : ''})
      }
    }

    if ((filterData?.active && !filterData?.inactive) || (!filterData?.active && filterData?.inactive)) {
      Object.assign(obj, {is_active: filterData?.active === true ? true : filterData?.inactive === true && false});
    }
    this.props.getCustomers(obj);
    this.closeDrawer();
  };

  //clear filter
  onClearFilter = () => {
    this.setState({
      filterData: {
        active: false,
        inactive: false,
        franchise: 'all',
        joined: [],
        lastService: [],
        outstanding: [],
        satisfaction: ''
      }
    }, () => {
      setTimeout(() => this.onFilterClick(), 1500)
    });
  };

  // close customer filter drawer
  closeDrawer = () => {
    this.setState({openDrawer: false});
  };

  //Table Order and Pagination
  onCustomerTableChange = (pagination, filters, sorter) => {
    const {
      customerListPagination,
      filterData,
      activePagination,
      search_value,
      current_tab
    } = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    let ordering = ''
    Object.assign(customerListPagination, { current: pagination.current });

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = '-created_at'
    }

    Object.assign(filterData, {franchise: filterData?.franchise});
    
    this.setState({
      customerListPagination,
      loader: true,
      filterData,
      is_active: current_tab === 1
    });

    const active = current_tab === 2 ? filterData?.active === true ? true : filterData?.inactive === true && false : true;

    let obj = {
      offset: ((pagination.current - 1) * activePagination),
      limit: pagination?.pageSize,
      ordering,
      q: search_value,
      serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
      is_active: active
    }
    if (filters?.franchise || (filterData?.franchise && filterData?.franchise !== 'all')) {
      Object.assign(obj, {serviceorder__field_office__uuid: filters?.franchise?.toString() || filterData?.franchise});
    }
    if (filterData?.joined?.length > 0) {
      Object.assign(obj, {created_at__lte: new Date(filterData?.joined?.[1]), created_at__gte: new Date(filterData?.joined?.[0])});
    }

    if (filterData?.lastService?.length > 0) {
      Object.assign(obj, {last_serviced: `${moment(filterData?.lastService?.[0]).format('YYYY-MM-DD')},${moment(filterData?.lastService?.[1]).format('YYYY-MM-DD')}`});
    }

    if(filterData?.satisfaction) {
      if(filterData?.satisfaction === '>=90' || filterData?.satisfaction === '>=75' ) {
        Object.assign(obj, {customer_satisfaction_score__gte: filterData?.satisfaction ? filterData?.satisfaction === '>=90' ? '90' : '75' : ''})
      }
      else {
        Object.assign(obj, {customer_satisfaction_score__lte: filterData?.satisfaction ? filterData?.satisfaction === '<75' ? '75' : '50' : ''})
      }
    }

    if ((filterData?.active && !filterData?.inactive) || (!filterData?.active && filterData?.inactive)) {
      Object.assign(obj, {is_active: filterData?.active === true ? true : filterData?.inactive === true && false});
    }

    this.props.getCustomers(obj);

  }

  // page size change
  setCustomerPageLimit = (value) => {
    const {customerListPagination, filterData, search_value, filters, current_tab} = this.state;
    Object.assign(customerListPagination, { current: 1, pageSize: value, ordering: '-created_at' });
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();

    this.setState({activePagination: value, customerListPagination});
  
    let obj = {
      offset: 0,
      limit: value,
      ordering: '-created_at',
      q: search_value,
      serviceorder__field_office__uuid: is_franchise_owner ? franchise_uuid : '',
      is_active: current_tab === 1
    };
    if (filters?.franchise || (filterData?.franchise && filterData?.franchise !== 'all')) {
      Object.assign(obj, {serviceorder__field_office__uuid: filters?.franchise?.toString() || filterData?.franchise});
    }
    if (filterData?.joined?.length > 0) {
      Object.assign(obj, {created_at__lte: new Date(filterData?.joined?.[1]), created_at__gte: new Date(filterData?.joined?.[0])});
    }
    if ((filterData?.active && !filterData?.inactive) || (!filterData?.active && filterData?.inactive)) {
      Object.assign(obj, {is_active: filterData?.active === true ? true : filterData?.inactive === true && false});
    }

    this.props.getCustomers(obj);
  };

  // on customer list row
  onCustomerListRow = (record) => {
    return {
      onClick: () => {
        isLeadClicked = false;
        this.props.history.push(`/residential/detail`, { query: { 'id': record?.uuid, hear_about_us: record?.hear_about_us, customer_satisfaction_score: record?.customer_satisfaction_score } })
      }
    }
  }

  ////////////////////////////// Lead ///////////////////////////
  // Lead filter data change
  onLeadFilterChange = (e, type, name) => {
    const {filterLeadData} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    Object.assign(filterLeadData, {[e.target.name]: value});
    if (e.target.name === 'inactive') Object.assign(filterLeadData, {lead_stage: 'all'})
    this.setState({filterLeadData}, () => {
      if (name === 'franchise') {
        this.onLeadFilterClick()
      }
    });
  };

  // on Lead filter click
  onLeadFilterClick = () => {
    const {filterLeadData, activeLeadPagination, leadListPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
    this.setState({loader: true, lead_search_value: ''});
    const obj = {
      offset: 0,
      limit: activeLeadPagination,
      ordering: '',
      field_office__uuid: is_franchise_owner ? franchise_uuid : ''
    };

    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDT00:00:00')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDT23:59:59')}`})
    }

    this.props.getLeads(obj);
    this.setState({leadListPagination: {...leadListPagination, current: 1}})
    this.closeLeadDrawer();
  };

  //clear lead filter
  onClearLeadFilter = () => {
    this.setState({
      filterLeadData: {
        active: false,
        inactive: false,
        franchise: 'all',
        lead_stage: 'all',
        outreach: 'all',
        first_contacted: [],
        last_contacted: []
      }
    }, () => {
      setTimeout(() => this.onLeadFilterClick(), 1500)
    });
  };

  // close lead filter drawer
  closeLeadDrawer = () => {
    this.setState({openLeadDrawer: false});
  };

  // Leads Table Order and Pagination
  onLeadTableChange = (pagination, filters, sorter) => {
    const {leadListPagination, activeLeadPagination, filterLeadData, search_value} = this.state;
    let ordering = ''
    Object.assign(leadListPagination, { current: pagination.current });
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    this.setState({
      leadListPagination,
      loader: true,
    });

    let obj = { 
      offset: ((pagination.current - 1) * activeLeadPagination), 
      limit: pagination?.pageSize, ordering,
      field_office__uuid: is_franchise_owner ? franchise_uuid : '', 
      q: search_value 
    }

    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDThh:mm:ss')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDThh:mm:ss')}`})
    }

    this.props.getLeads(obj);
  }

  // leads page size change
  setLeadPageLimit = (value) => {
    const {leadListPagination, filterLeadData, search_value} = this.state;
    Object.assign(leadListPagination, { current: 1, pageSize: value, ordering: '', q: search_value });
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()

    this.setState({activeLeadPagination: value, leadListPagination});
    let obj = { offset: 0, limit: value, ordering: '', field_office__uuid: is_franchise_owner ? franchise_uuid : ''}
    
    if (filterLeadData?.franchise && filterLeadData?.franchise !== 'all') {
      Object.assign(obj, {field_office__uuid: filterLeadData?.franchise});
    }

    if ((filterLeadData?.active && !filterLeadData?.inactive) || (!filterLeadData?.active && filterLeadData?.inactive)) {
      Object.assign(obj, {is_active: filterLeadData?.active === true ? true : filterLeadData?.inactive === true && false});
    }

    if (filterLeadData?.lead_stage && filterLeadData?.lead_stage !== 'all') {
      Object.assign(obj, {lead_profile__stage: filterLeadData?.lead_stage})
    }

    if (filterLeadData?.outreach && filterLeadData?.outreach !== 'all') {
      Object.assign(obj, {lead_profile__outreach: filterLeadData?.outreach})
    }

    if (filterLeadData?.last_contacted?.length > 0) {
      Object.assign(obj, {lead_status_logs__created_at__range: `${moment(filterLeadData?.last_contacted?.[0]).format('YYYY-MM-DDThh:mm:ss')}, ${moment(filterLeadData?.last_contacted?.[1]).format('YYYY-MM-DDThh:mm:ss')}`})
    }

    this.props.getLeads(obj);
  };

  // on lead list row
  onLeadListRow = (record) => {
    return {
      onClick: () => {
        isLeadClicked = true
        this.props.history.push(`/residential/lead/detail`, { query: { 'id': record?.uuid, hear_about_us: record?.hear_about_us } })
      }
    }
  }
  ///////////////////////////////////////////////////////////

  // render customer filter drawer
  renderDrawer = () => {
    const {
      openDrawer,
      filterData,
      franchiseList,
    } = this.state;

    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={this.closeDrawer}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="group_wrapper rdrawer">
          <div className="card-head">
            <h4>Filter Customer</h4>
          </div>
          <div className="card-row">
            <div className="card-full">
              {/* <CloseOutlined onClick={() => this.closeDrawer()}/>                   */}
              <div className="form-group">
                {/*<div className="fitem">*/}
                {/*  <label>Customer Status</label>*/}
                {/*  <div className="fitem-check">*/}
                {/*    <input*/}
                {/*      type="checkbox"*/}
                {/*      className="fitem-ck-input"*/}
                {/*      id={`active`}*/}
                {/*      name={'active'}*/}
                {/*      checked={filterData?.active}*/}
                {/*      onChange={(e) => this.onFilterChange(e, 'bool')} />*/}
                {/*    <label htmlFor={`active`} className="fitem-ck-txt mb-0">{'Active'}</label>*/}
                {/*  </div>*/}
                {/*  <div className="fitem-check">*/}
                {/*    <input*/}
                {/*      type="checkbox"*/}
                {/*      className="fitem-ck-input"*/}
                {/*      id={`inactive`}*/}
                {/*      name={'inactive'}*/}
                {/*      checked={filterData?.inactive}*/}
                {/*      onChange={(e) => this.onFilterChange(e, 'bool')} />*/}
                {/*    <label htmlFor={`inactive`} className="fitem-ck-txt mb-0">{'Inactive'}</label>*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="fitem">
                  <label htmlFor="customerFranchise">Franchise</label>
                  <Select
                    disabled={is_disable_franchise_dropdown}
                    id={"customerFranchise"}
                    placeholder="Select a Franchise"
                    name="franchise"
                    onChange={(e) => this.onFilterChange({target: {name: 'franchise', value: e}})}
                    value={filterData?.franchise || undefined}>
                    <Option key={'franchiseAll'} value={'all'}>{'All'}</Option>
                    {
                      orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)
                    }
                  </Select>
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Joined</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterData?.joined?.length > 0 ? [filterData?.joined?.[0] ? moment(filterData?.joined?.[0]) : undefined, filterData?.joined?.[1] ? moment(filterData?.joined?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.onFilterChange({ target: { name: 'joined', value: [] } });
                      } else {
                        this.onFilterChange({ target: { name: 'joined', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Last Serviced</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterData?.lastService?.length > 0 ? [filterData?.lastService?.[0] ? moment(filterData?.lastService?.[0]) : undefined, filterData?.lastService?.[1] ? moment(filterData?.lastService?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.onFilterChange({ target: { name: 'lastService', value: [] } });
                      } else {
                        this.onFilterChange({ target: { name: 'lastService', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>
                {/*
                <div className="fitem">
                  <label htmlFor="customerFranchise">Balance Outstanding</label>
                  <Select
                    placeholder="Enter Range"
                    name="outstanding"
                    onChange={(e) => this.onFilterChange({target: {name: 'outstanding', value: e}})}
                    value={filterData?.outstanding || undefined}>
                    {
                      franchiseList?.results?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)
                    }
                  </Select>
                </div>
*/}
                <div className="fitem">
                  <label htmlFor="customerFranchise">Satisfaction Score</label>
                  <Select
                    placeholder="Enter Satisfaction Score"
                    name="satisfaction"
                    onChange={(e) => this.onFilterChange({target: {name: 'satisfaction', value: e}})}
                    value={filterData?.satisfaction || undefined}>
                    {
                      satisfaction_score?.map((option) =>
                        <Option key={option?.key} value={option?.key}>{option?.value}</Option>)
                    }
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn`} onClick={() => {this.closeDrawer();this.onClearFilter();}}>Cancel</button>
            <button
              // type="submit"
              className={`btn`}
              onClick={() => this.onFilterClick()}>
              Filter Customer
            </button>
          </div>
        </div>
      </Drawer>
    )
  };

  // render Lead filter drawer
  renderLeadDrawer = () => {
    const {
      openLeadDrawer,
      filterLeadData,
      franchiseList,
    } = this.state;
    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={this.closeLeadDrawer}
        visible={openLeadDrawer}
        key={'rightLead'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="group_wrapper rdrawer">
          <div className="card-head">
            <h4>Filter Leads</h4>
          </div>
          <div className="card-row">
            <div className="card-full">
              {/* <CloseOutlined onClick={() => this.closeDrawer()}/>                   */}
              <div className="form-group">
                <div className="fitem">
                  <label>Lead Status</label>
                  <div className="fitem-check">
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`active`}
                      name={'active'}
                      checked={filterLeadData?.active}
                      onChange={(e) => this.onLeadFilterChange(e, 'bool')} />
                    <label htmlFor={`active`} className="fitem-ck-txt mb-0">{'Active'}</label>
                  </div>
                  <div className="fitem-check">
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`inactive`}
                      name={'inactive'}
                      checked={filterLeadData?.inactive}
                      onChange={(e) => this.onLeadFilterChange(e, 'bool')} />
                    <label htmlFor={`inactive`} className="fitem-ck-txt mb-0">{'Inactive'}</label>
                  </div>
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Franchise</label>
                  <Select
                    disabled={is_disable_franchise_dropdown}
                    id={"customerFranchise"}
                    placeholder="Select a Franchise"
                    name="franchise"
                    onChange={(e) => this.onLeadFilterChange({target: {name: 'franchise', value: e}})}
                    value={filterLeadData?.franchise || undefined}>
                    <Option key={'franchiseAll'} value={'all'}>{'All'}</Option>
                    {
                      orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)
                    }
                  </Select>
                </div>
                <div className="fitem">
                  <label htmlFor="lead_stage">Lead Stage</label>
                  <Select
                    disabled={filterLeadData?.inactive}
                    id={"lead_stage"}
                    value={filterLeadData?.lead_stage || undefined}
                    placeholder={"Lead Stage"}
                    onChange={(e) => this.onLeadFilterChange({target: {name: 'lead_stage', value: e}})}
                    dropdownClassName="md-filter">
                    <Option key={'leadAll'} value={'all'}>{'All'}</Option>
                    <Option value="new">New</Option>
                    <Option value="contacted">Contacted</Option>
                    <Option value="interested">Interested</Option>
                    {/*<Option value="customer">Customer</Option>*/}
                  </Select>
                </div>
                <div className="fitem">
                  <label htmlFor="outreach">Outreach</label>
                  <Select
                    id={"outreach"}
                    value={filterLeadData?.outreach}
                    placeholder={"Outreach"}
                    onChange={(e) => this.onLeadFilterChange({target: {name: 'outreach', value: e}})}
                    dropdownClassName="md-filter">
                    <Option key={'outreachAll'} value={'all'}>{'All'}</Option>
                    <Option value="website">Website</Option>
                    <Option value="call_center">Call Center</Option>
                    <Option value="franchisee">Franchisee</Option>
                  </Select>
                </div>
                {/*<div className="fitem">
                  <label htmlFor="first_contacted">First Contacted</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterLeadData?.first_contacted?.length > 0 ? [filterLeadData?.first_contacted?.[0] ? moment(filterLeadData?.first_contacted?.[0]) : undefined, filterLeadData?.first_contacted?.[1] ? moment(filterLeadData?.first_contacted?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.onLeadFilterChange({ target: { name: 'first_contacted', value: [] } });
                      } else {
                        this.onLeadFilterChange({ target: { name: 'first_contacted', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>*/}
                <div className="fitem">
                  <label htmlFor="last_contacted">Last Contacted</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterLeadData?.last_contacted?.length > 0 ? [filterLeadData?.last_contacted?.[0] ? moment(filterLeadData?.last_contacted?.[0]) : undefined, filterLeadData?.last_contacted?.[1] ? moment(filterLeadData?.last_contacted?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.onLeadFilterChange({ target: { name: 'last_contacted', value: [] } });
                      } else {
                        this.onLeadFilterChange({ target: { name: 'last_contacted', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn`} onClick={() => {this.closeLeadDrawer(); this.onClearLeadFilter()}}>Cancel</button>
            <button
              // type="submit"
              className={`btn`}
              onClick={() => this.onLeadFilterClick()}>
              Filter Leads
            </button>
          </div>
        </div>
      </Drawer>
    )
  };

  onActionChange = (e, action, uuid, row) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({uuid: uuid, selectedRow: row}, () => {
      switch (action) {
      case 'edit':
        this.props.history.push(`/residential/detail`, { query: { 'id': row?.uuid, hear_about_us: row?.hear_about_us, customer_satisfaction_score: row?.customer_satisfaction_score, selectedTab: 1 } })
        break;
      default:
        console.log('no action')
      }
    })
  }

  // render table action
  renderAction = (uuid, row) => {
    const menu = (
      <Menu>
        <Menu.Item key="0"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'edit', uuid, row)}>Edit</a></Menu.Item>
      </Menu>
    )

    return (
      <Dropdown overlay={menu} trigger={['hover']}>
        <span onClick={e => e.preventDefault()}>
          <EllipsisOutlined />
        </span>
      </Dropdown>
    )
  }
  
  //render customer list
  renderCustomerList = () => {
    const {
      customerList,
      customerListPagination,
      franchiseList,
      activePagination,
      search_value
    } = this.state;

    const franchise = franchiseList?.results?.map((item) => ({text: item?.name, value: item?.uuid}));
    return (
      <div className="leadstbl">
        <Table
          rowKey={record => record?.uuid}
          dataSource={customerList?.results}
          pagination={{...customerListPagination, total: customerList?.count}}
          columns={DataTable.customerColumns(franchise, search_value, this)}
          onChange={this.onCustomerTableChange}
          onRow={this.onCustomerListRow}
          className="customer-list"
        />
        {customerList?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCustomerPageLimit('15') }}
                className={activePagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activePagination === '30' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={activePagination === '60' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  };

  //render cancelled customer
  renderCancelledCustomer = () => {
    const {
      customerList,
      customerListPagination,
      franchiseList,
      activePagination,
      search_value
    } = this.state;

    const franchise = franchiseList?.results?.map((item) => ({text: item?.name, value: item?.uuid}));
    return (
      <div className="leadstbl">
        <Table
          rowKey={record => record?.uuid}
          dataSource={customerList?.results}
          pagination={{...customerListPagination, total: customerList?.count}}
          columns={DataTable.customerColumns(franchise, search_value, this)}
          onChange={this.onCustomerTableChange}
          onRow={this.onCustomerListRow}
          className="customer-list"
        />
        {customerList?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setCustomerPageLimit('15') }}
                className={activePagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activePagination === '30' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={activePagination === '60' ? 'active' : ''}
                onClick={() => { this.setCustomerPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  };

  //render lead list
  renderLeadsList = () => {
    const {
      leadList,
      leadListPagination,
      activeLeadPagination,
      lead_search_value
    } = this.state;

    return (
      <div>
        <Table
          rowKey={record => record?.uuid}
          dataSource={leadList?.results}
          pagination={{...leadListPagination, total: leadList?.count}}
          columns={DataTable.leadColumns(lead_search_value)}
          onChange={this.onLeadTableChange}
          onRow={this.onLeadListRow}
          className="customer-list"
        />
        {leadList?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setLeadPageLimit('15') }}
                className={activeLeadPagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activeLeadPagination === '30' ? 'active' : ''}
                onClick={() => { this.setLeadPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={activeLeadPagination === '60' ? 'active' : ''}
                onClick={() => { this.setLeadPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  };

  render() {
    const {
      filterData,
      franchiseList,
      current_tab,
      loader,
      search_value,
      showAddLeadDrawer,
      filterLeadData,
    } = this.state;
    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder={'Acc Number, Customer Name, Address(Billing), Phone Number, Email Address'}
            search_value={search_value}
            onSearch={this.onSearch}
            onEnter={(e) => e.target.value.length>2?this.setState({search_value: '', loader: true}, () => this.onSearch(e)):alert("Enter at least 3 character!")}
          />

          {/* Sidebar */}
          <Sidebar />


          <div className="container">
            {loader && <Loader/>}
            <div className="filter_wrapper">
              <div className="left_side">
                <div className="fitem">
                  <Select
                    disabled={is_disable_franchise_dropdown}
                    className="swhite"
                    placeholder="Select a Franchise"
                    name="franchise"
                    onChange={(e) => (current_tab === 1 || current_tab === 2) ? this.onFilterChange({target: {name: 'franchise', value: e}}, '', 'franchise') : current_tab === 0 ? this.onLeadFilterChange({target: {name: 'franchise', value: e}}, '', 'franchise') : null}
                    value={(current_tab === 1 || current_tab === 2) ? filterData?.franchise || undefined : current_tab === 0 ? filterLeadData?.franchise || undefined : undefined}>
                    <Option key={'franchiseAll'} value={'all'}>{'All Franchises'}</Option>
                    {
                    orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                      <Option key={option?.uuid} value={option?.uuid}>{`${this.leadingZeros(option?.id, 3)} ${option?.name}`}</Option>)
                    }
                  </Select>
                </div>
                <ul className="tabs">
                  <li className={current_tab === 0 ? 'active' : ''} onClick={() => { this.switchTab(0); }}>
                    <span>{`NEW  LEADS`}</span>
                  </li>
                  <li className={current_tab === 1 ? 'active' : ''} onClick={() => { this.switchTab(1); }}>
                    <span>CUSTOMERS</span>
                  </li>
                  <li className={current_tab === 2 ? 'active' : ''} onClick={() => { this.switchTab(2); }}>
                    <span>{`CANCELLED CUSTOMERS`}</span>
                  </li>
                </ul>
              </div>
              <div className="right_side">
                <span className="ico-btn">
                  <FilterOutlined onClick={() => (current_tab === 1 || current_tab === 2) ? this.setState({openDrawer: true}) : current_tab === 0 ? this.setState({openLeadDrawer: true}) : null}>Filter</FilterOutlined>
                </span>
                {current_tab === 2 ? '' : <button className="btn btn-warning"
                  onClick={() => current_tab === 1 ? this.props.history?.push('/residential/new-customer') : current_tab === 0 ? this.toggleAddLeadDrawer(true) : null}
                >{current_tab === 1 ? `Add New Customer` : current_tab === 0 ? 'Add New Lead' : ''}</button> }
              </div>
            </div>
            <div className="data leadstable">
              {current_tab === 1 ? this.renderCustomerList() : current_tab === 0 ? this.renderLeadsList() : this.renderCancelledCustomer()}
            </div>
            {this.renderDrawer()}
            {this.renderLeadDrawer()}
            <AddLead 
              visible={showAddLeadDrawer}
              closeDrawer={() => this.toggleAddLeadDrawer(false)}
              addLeads={this.props.addLeads}
              getLeads={this.props.getLeads}
              lead={this.props.Lead}
              history={this.props.history}
              checkZipCode={this.props.checkZipCode}
              getGeocodeAddress={this.props.getGeocodeAddress} // api
              resetGeocodeAddress={this.props.resetGeocodeAddress}
              GoogleApi={this.props.GoogleApi} // reducer
              ZipcodeCheck={this.props.ZipcodeCheck}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CustomerList;
